/**
 * @module domain/donor
 * @description Pure donor-field validation for checkout (brief §4.8).
 */
import type { DonorInfo } from "./types";

/** Field-level errors; a missing key means the field is valid. */
export type DonorErrors = Partial<Record<keyof DonorInfo, string>>;

/** Pragmatic email shape check (the real check is Neon's receipt email). */
const EMAIL_PATTERN: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** @returns errors for the required donor fields. */
export function validateDonor(donor: DonorInfo): DonorErrors {
    const errors: DonorErrors = {};
    if (donor.firstName.trim() === "") errors.firstName = "Please enter your first name.";
    if (donor.lastName.trim() === "") errors.lastName = "Please enter your last name.";
    if (!EMAIL_PATTERN.test(donor.email.trim())) errors.email = "Please enter a valid email for your receipt.";
    if (donor.postalCode.trim() === "") errors.postalCode = "Please enter your ZIP or postal code.";
    return errors;
}

/** @returns true when there are no errors. */
export function isValid(errors: DonorErrors): boolean {
    return Object.keys(errors).length === 0;
}
